var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1787 7H13.1787V5C13.1787 2.24 10.9387 0 8.17871 0C5.41871 0 3.17871 2.24 3.17871 5V7H2.17871C1.07871 7 0.178711 7.9 0.178711 9V19C0.178711 20.1 1.07871 21 2.17871 21H14.1787C15.2787 21 16.1787 20.1 16.1787 19V9C16.1787 7.9 15.2787 7 14.1787 7ZM5.17871 5C5.17871 3.34 6.51871 2 8.17871 2C9.83871 2 11.1787 3.34 11.1787 5V7H5.17871V5ZM14.1787 19H2.17871V9H14.1787V19ZM8.17871 16C9.27871 16 10.1787 15.1 10.1787 14C10.1787 12.9 9.27871 12 8.17871 12C7.07871 12 6.17871 12.9 6.17871 14C6.17871 15.1 7.07871 16 8.17871 16Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.32155ad6cd028dbe72c96651457fb634.svg";
export { ForwardRef as ReactComponent };